export enum MessageTriggerTypeEnum {
  SuggestedFollowup = 'SUGGESTED_FOLLOWUP',
  Automated = 'AUTOMATED',
  LinkedinTask = 'LINKEDIN_TASK',
}
